import localVideo from './video-file'
import youtube from './youtube'
import stream from './stream'

const state = {
  showStream    : true,
  showVideo     : true,
  showYoutube   : true,
  localStream   : '',
  remoteStreams : []
}
const getters = {
  remoteStreams : state => state.remoteStreams,
  localStream   : state => state.localStream
}
const mutations = {
  setLocalStream  (state, stream) { state.localStream = stream },
  addRemoteStream (state, stream) { state.remoteStreams.push(stream) }
}
const actions   = {}

export default {
  namespaced : true,
  state,
  getters,
  mutations,
  actions,
  modules    : {
    localVideo,
    youtube,
    stream
  }
}



// WEBPACK FOOTER //
// ./src/components/video/store/index.js